import Vue from 'vue';

Vue.component('payment-index', () =>
    import(/* webpackChunkName: 'payment-index' */ './payment-index.vue'),
);
